import React, { Component } from 'react';

class Wrapper extends Component
{
    render = () => {
        return (
            <div className={ ['container', this.props.outerClass].join(' ') }>
                { this.props.injectTop }
                <div className={ ['container-inner', this.props.innerClass].join(' ') }>
                    { this.props.children }
                </div>
                { this.props.injectBottom }
            </div>
        );
    }
}

Wrapper.defaultProps = {
    outerClass  : null,
    innerClass  : null,
    injectTop   : null,
    injectBottom: null
};

export default Wrapper;


// WEBPACK FOOTER //
// ./src/components/Wrapper.js